import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=6aa41e76&scoped=true"
import script from "./Editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./Editor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Editor.vue?vue&type=style&index=0&id=6aa41e76&prod&lang=scss"
import style1 from "./Editor.vue?vue&type=style&index=1&id=6aa41e76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa41e76",
  null
  
)

export default component.exports